import React from 'react';
import HighlightsCard from '../HighlightsCard';
import { useTileData } from '../../../hooks/useTileData';
import { getAimSnapshot } from '../../../api/auth';

// AKS bucket labels — matches ratingScale.js in the AIM module.
const captionFor = (aks) => {
  if (!Number.isFinite(aks)) return 'AI knowledge score';
  if (aks >= 80) return 'Excellent';
  if (aks >= 60) return 'Solid';
  if (aks >= 40) return 'Needs work';
  return 'Low visibility';
};

export default function AiVisibilityHighlight({ clientId }) {
  const { data, loading, error } = useTileData(
    async () => {
      const resp = await getAimSnapshot(clientId, 'P1', '', null);
      const rows = Array.isArray(resp?.data) ? resp.data : (resp?.data ? [resp.data] : []);
      return rows[0] ?? null;
    },
    [clientId],
    Boolean(clientId),
  );

  const aks = data?.value_numeric != null ? Number(data.value_numeric) : null;

  return (
    <HighlightsCard
      label="AI Visibility"
      value={aks != null ? aks.toFixed(1) : '—'}
      delta={null}
      caption={captionFor(aks)}
      loading={loading}
      error={error}
    />
  );
}
